import React from 'react';
import { Container } from 'reactstrap';
import './Home.css';

const Home = () => (
  <div className="App">
    <Container>
      <a target="noopener noreferrer" href="https://homelane.com">
        <img
          src="https://d7gpgy8svgdhy.cloudfront.net/0.0.15/images/rsz_hl_logo4.png"
          alt="HomeLane"
        />
      </a>
    </Container>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/index.js